import type { InjectionKey, MaybeRefOrGetter } from 'vue';

/**
 * Id used to identify the special 'block' that is a slot outlet.
 */
export const slotOutletBlockId = '__dsSlotOutlet';

/**
 * Key used to inject the boolean used in `useBlockInEditor()`.
 */
export const inBlockEditorKey = '__dsInBlockEditor';

/**
 * Key used to inject the boolean indicating that the layout is horizontal.
 */
export const horizontalLayoutKey = Symbol('__dsHorizontalLayout') as InjectionKey<MaybeRefOrGetter<boolean>>;

/**
 * Slot to display content when a serialized block is empty.
 */
export const emptyBlockSlot = 'dsEmptyBlockSlot';

/**
 * If the block doesn't have a single root element, this key is used to provide the block reference.
 *
 * It is recommended to have a single static root display:block element in the block. Block should not have multiple root elements.
 */
export const blockRefKey = Symbol('blockRefKey');

/**
 * Prefix used to generate the id of the block preview Child object.
 */
export const blockPreviewIdPrefix = '__dsBlockPreview';
